// src/hooks/useResponsiveArticles.js
import { useEffect, useState } from 'react';

function getNumberOfArticles(width) {
  if (width < 640) return 4;
  else if (width < 768) return 5;
  else if (width < 1024) return 6;
  else if (width < 1280) return 7;
  else return 9;
}

function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}

function useResponsiveArticles() {
  // Initialize state from current width, avoids first render mismatch
  const [articles, setArticles] = useState(() => getNumberOfArticles(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const newCount = getNumberOfArticles(width);
      setArticles(newCount);
    };

    const debouncedResize = debounce(handleResize, 150);
    window.addEventListener('resize', debouncedResize);

    // Call once immediately to set the correct count on mount
    handleResize();

    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, []);

  return articles;
}

export default useResponsiveArticles;
